import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { TableCell, TableContainer } from "@mui/material";

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(1rem);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const WrapperRoot = styled.div`
  position: absolute;
  z-index: 99;
  padding-top: 30px;

  left: -18px;
  right: -18px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    left: 38px;
    right: 38px;
  }

  animation: ${fadeIn} 0.3s ease-in-out;

  &::after {
    content: url("/assets/svg/arrowDecor.svg");
    position: absolute;
    top: 16px;
    right: 14%;
    display: block;

    @media (max-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      right: 50%;
      transform: translateX(50%);
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;

  &::after {
    content: url("/assets/svg/arrowDecor.svg");
    position: absolute;
    top: -12px;
    right: 14%;
    display: block;

    @media (max-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      right: 50%;
      transform: translateX(50%);
    }
  }
`;

export const ContainerTable = styled(TableContainer)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 20px;
`;

export const HeadCell = styled(TableCell)`
  font-weight: ${p => p.theme.fontWeight.medium};
  padding: 20px;
  border: none;

  font-size: 16px;
  text-align: ${prop => (prop.idx !== 0 ? "center" : "left")};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 28px;
  }
`;

export const BodyCell = styled(TableCell, {
  shouldForwardProp: prop =>
    prop !== "isOdd" &&
    prop !== "full" &&
    prop !== "center" &&
    prop !== "radius",
})`
  ${props =>
    props.full &&
    `
    line-height: normal;
    font-weight: 400;
    padding: 16px 20px;
    border-bottom: none;
    border-radius: 15px 0 0 15px;
    font-size: 14px;
    border-bottom: none;
  `}

  ${props =>
    props.center &&
    `
        text-align: center;
  `}

   ${props =>
    props.radius &&
    `
        border-radius: 0 15px 15px 0;
  `}

  border-bottom: none;
  background-color: ${prop =>
    prop.isOdd ? "inherit" : prop.theme.colors.background};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
  }
`;
